import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModalAuditState } from './modal-audit.state';

export const featureKey = 'modalAudit';

export const ModalAuditFeature = createFeatureSelector<ModalAuditState>(featureKey);

export const selectState = createSelector(ModalAuditFeature, (state: ModalAuditState) => state);
export const selectApplication = createSelector(ModalAuditFeature, ({ application }: ModalAuditState) => application);
export const selectStudents = createSelector(ModalAuditFeature, ({ students }: ModalAuditState) => students);
export const selectQuestions = createSelector(ModalAuditFeature, ({ questions }: ModalAuditState) => questions);

export const selectStudentActive = createSelector(ModalAuditFeature, ({ students }: ModalAuditState) =>
  students?.find((student) => !!student.selected),
);

export const selectQuestionActive = createSelector(ModalAuditFeature, ({ questions }: ModalAuditState) =>
  questions?.find((question) => !!question.selected),
);
